<template lang="html">
	<section class="main demo-master">
		<h1>Demo Section</h1>
		<article class="content-demo">
			<h2>Icons</h2>
			<div class="content icons">
				<span :class="generateIconName(icon)" v-for="(icon, key) in icons" @click="copyIcon(key)" v-bind:key="key"></span>
			</div>
		</article>
	</section>
</template>

<script>
export default {
	name: 'Demo',
	data () {
		return {
			icons: [
				'alert',
				'arrow-back',
				'clock',
				'down-open-mini',
				'left-open-mini',
				'up-open-mini',
				'right-open-mini',
				'arrow-full-down',
				'arrow-full-left',
				'arrow-full-up',
				'arrow-full-right',
				'article-details',
				'article-share',
				'bandeau-alert',
				'button-add',
				'button-contact',
				'button-download',
				'button-diffusion',
				'button-new-mission',
				'button-rdv',
				'button-relance',
				'button-send',
				'button-situation',
				'button-warning',
				'doc-lettre-mission',
				'doc-cr-mission',
				'doc-others',
				'doc-paysage',
				'doc-print',
				'doc-private',
				'doc-template',
				'document-pdf',
				'download-pdf',
				'dynamique',
				'eye',
				'fiche-client-calandar',
				'fiche-client-docs',
				'fiche-client-history',
				'fiche-client-info',
				'fiche-client-note',
				'fiche-client-paysage',
				'file-edit',
				'file-trash',
				'form-close',
				'form-plus',
				'info-2',
				'info',
				'nav-actu',
				'loupe',
				'nav-admin-cabinets',
				'nav-admin-clients',
				'nav-admin-conseiller',
				'nav-admin-encaissement',
				'nav-admin-stat',
				'nav-conseiller',
				'nav-docs',
				'nav-help',
				'nav-notif',
				'nav-operation',
				'nav-placements',
				'notif-article',
				'notif-docs',
				'operations-folder',
				'paysage-entreprise-actionaire',
				'paysage-entreprise-activite',
				'paysage-entreprise-benef',
				'paysage-entreprise-dirigeants',
				'paysage-entreprise-docs',
				'paysage-entreprise',
				'paysage-fiscalite',
				'paysage-profil',
				'paysage-rentree',
				'paysage-retraite',
				'paysage-sortis',
				'paysage-vous',
				'social-fb',
				'social-google',
				'social-lkd',
				'volet-notif'
			]
		}
	},
	methods: {
		generateIconName (a) {
			return 'icon-' + a
		},
		copyIcon (key) {
			navigator.clipboard.writeText('<span class="' + this.generateIconName(this.icons[key]) + '"></span>')
		}
	}
}
</script>

<style lang="scss" scoped>
	h1 {
		text-align: center;
		margin: 2rem 0;
	}

	h2 {
		text-align: center;
		margin: 1rem 0;
		font-size: 1.4rem;
	}

	.code {
		border-radius: 5px;
		background-color: rgba(#606060, 0.4);
		padding: 1rem;
		margin: 1rem;
		font-size: 0.8rem;
	}

	.content.icons {
		span {
			font-size: 2rem;
			cursor: pointer;
		}
	}

	.demo-master {
		padding: 2rem 0;
		padding-bottom: 20rem;
	}
</style>



// WEBPACK FOOTER //
// src/views/Demo.vue